
import { Vue } from "vue-class-component";

class LeaderboardNationalIcon extends Vue {}
export default LeaderboardNationalIcon;
